<template>
<div>
    <Header :title="pageTitle" />
    <div class="scrollerView">
        <scroller :on-refresh="refresh" :on-infinite="infinite" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
            <courseItem v-for="(item, index) in dataSources" :key="index" :item="item" :type="4" />
            <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
        </scroller>
    </div>
</div>
</template>

<script>
import Header from '@/components/Header'
import courseItem from '@/components/item/courseItem'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header,
        'courseItem': courseItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            pageTitle: this.$route.query.text || '义工记录',
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 1,
            limit: 10,
            keyword: '',
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestData();
    },
    /** 方法 */
    methods: {
        // 刷新
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(function () {
                this.$refs.infinite.finishPullToRefresh();
            }.bind(this), 1000)
        },
        // 继续请求
        infinite() {
            this.page++
            this.requestData();
        },
        // 请求首页数据
        async requestData() {
            let url = this.API.volunteer_my_volunteer_log;
            let params = {type: 0, // 0未服务1已服务
                page: this.page,
                limit: this.limit,
            };
            let result = await this.$post(url, params);
            let dataSourcesTemp = this.dataSources.slice();
            let dataList = result.data.data;
            let that = this;
            if (result.code === that.GLOBAL.SUCCESS_CODE) {
                if (that.page === 1) {
                    dataSourcesTemp = dataList
                    that._dataSource = result.data.to_work_list;
                } else {
                    if (dataList.length !== 0) {
                        dataSourcesTemp = dataSourcesTemp.concat(dataList)
                    }
                }
                that.dataSources = dataSourcesTemp
                that.$refs.infinite.finishInfinite(dataList.length < that.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
    height: 100vh;
}

.scroller {
    background: #F8F8F8;
}

.header {
    position: relative;
    height: 60px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;

    .left-btn {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
            display: block;
            height: 20px;
            opacity: .8;
        }
    }

    .search {
        flex: 1;
        padding: 0 10px;
        margin-left: 30px;
        height: 34px;
        display: flex;
        align-items: center;
        background: #F5F5F5;
        border-radius: 5px;

        img {
            width: 14px;
            height: 14px;
        }

        input {
            flex: 1;
            margin-left: 10px;
            font-size: 14px;
            color: #333;
        }

        div {
            width: 1px;
            height: 15px;
            margin: 0 10px;
            background: #E1D9D9;
        }

        p {
            font-size: 14px;
            color: #666;
        }
    }
}
</style>
